import type { LucideIcon } from 'lucide-react';
import {
  Antenna,
  Apple,
  Baby,
  Backpack,
  BedDouble,
  Bike,
  BookOpen,
  Briefcase,
  Building,
  Bus,
  Cake,
  Calendar,
  Camera,
  Car,
  ChefHat,
  Clipboard,
  Cloud,
  Coffee,
  Coins,
  Compass,
  CookingPot,
  Cpu,
  CreditCard,
  Dumbbell,
  FileSignature,
  FileText,
  Flower,
  Fuel,
  Gamepad,
  Gift,
  Glasses,
  GraduationCap,
  Hammer,
  HardDrive,
  Headphones,
  Heart,
  Home,
  Inbox,
  Key,
  Lamp,
  Laptop,
  Map,
  MapPin,
  Megaphone,
  Monitor,
  Mountain,
  Music,
  Network,
  PaintRoller,
  Paintbrush,
  PartyPopper,
  Palette,
  PawPrint,
  Phone,
  Pizza,
  Plane,
  Plug,
  Printer,
  Puzzle,
  Receipt,
  Router,
  Sailboat,
  Scissors,
  Server,
  ShoppingBasket,
  ShoppingCart,
  ShowerHead,
  Smartphone,
  Snowflake,
  Sofa,
  Sprout,
  Sun,
  Tablet,
  Tent,
  Thermometer,
  Ticket,
  Toilet,
  ToyBrick,
  Trees,
  Truck,
  Tv,
  Umbrella,
  Utensils,
  Volleyball,
  Wallet,
  WashingMachine,
  Watch,
  Wifi,
  Wrench,
  Zap,
} from 'lucide-react';

const ICON_MAP: Record<string, LucideIcon> = {
  home: Home,
  inbox: Inbox,
  building: Building,
  'bed-double': BedDouble,
  sofa: Sofa,
  lamp: Lamp,
  key: Key,
  'washing-machine': WashingMachine,
  'shower-head': ShowerHead,
  toilet: Toilet,
  utensils: Utensils,
  'cooking-pot': CookingPot,
  'shopping-cart': ShoppingCart,
  'shopping-basket': ShoppingBasket,
  sprout: Sprout,
  trees: Trees,
  flower: Flower,
  sun: Sun,
  umbrella: Umbrella,
  tent: Tent,
  car: Car,
  bike: Bike,
  plane: Plane,
  truck: Truck,
  bus: Bus,
  briefcase: Briefcase,
  'graduation-cap': GraduationCap,
  'book-open': BookOpen,
  wallet: Wallet,
  coins: Coins,
  calendar: Calendar,
  printer: Printer,
  clipboard: Clipboard,
  backpack: Backpack,
  watch: Watch,
  glasses: Glasses,
  scissors: Scissors,
  puzzle: Puzzle,
  palette: Palette,
  coffee: Coffee,
  apple: Apple,
  pizza: Pizza,
  'chef-hat': ChefHat,
  heart: Heart,
  baby: Baby,
  'paw-print': PawPrint,
  gift: Gift,
  'party-popper': PartyPopper,
  dumbbell: Dumbbell,
  music: Music,
  camera: Camera,
  gamepad: Gamepad,
  monitor: Monitor,
  laptop: Laptop,
  tablet: Tablet,
  smartphone: Smartphone,
  router: Router,
  wifi: Wifi,
  server: Server,
  cloud: Cloud,
  'hard-drive': HardDrive,
  cpu: Cpu,
  network: Network,
  antenna: Antenna,
  tv: Tv,
  phone: Phone,
  // Herramientas y mantenimiento
  hammer: Hammer,
  wrench: Wrench,
  'paint-roller': PaintRoller,
  paintbrush: Paintbrush,
  plug: Plug,
  thermometer: Thermometer,
  zap: Zap,
  // Dinero y admin
  'credit-card': CreditCard,
  receipt: Receipt,
  'file-text': FileText,
  'file-signature': FileSignature,
  // Viaje y exterior
  map: Map,
  compass: Compass,
  mountain: Mountain,
  ticket: Ticket,
  fuel: Fuel,
  sailboat: Sailboat,
  snowflake: Snowflake,
  'map-pin': MapPin,
  // Tech y media
  headphones: Headphones,
  // Familia y ocio
  cake: Cake,
  'toy-brick': ToyBrick,
  volleyball: Volleyball,
  megaphone: Megaphone,
};

/**
 * Icono de proyecto. Si `name` es un icono Lucide del catálogo lo pinta como
 * SVG (sigue el tema); si no (emoji legado guardado antes del selector) lo
 * renderiza como texto para no perder datos.
 */
export function ProjectIcon({
  name,
  className,
}: {
  name: string;
  className?: string;
}) {
  const Icon = ICON_MAP[name];
  if (Icon) {
    return <Icon className={className} aria-hidden="true" />;
  }
  return (
    <span className={className} aria-hidden="true">
      {name}
    </span>
  );
}
